// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ELHC","content":"styles_content__30S-2","row":"styles_row__w9shW","footer":"styles_footer__14NH1","phraseLength":"styles_phraseLength__1NcLC"};